import React from 'react';
import PropTypes from 'prop-types';
import convertTcmLink from '../../utils/convertTcmLink';

const Text = ({ text }) => (
  <p>{convertTcmLink(text)}</p>
);

Text.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Text;



// WEBPACK FOOTER //
// ./library/app/components/Content/Text.js